import { twMerge } from "tailwind-merge";
import { getLabel } from "../utils/labels";
import { useApp } from "../../../services/app-context";


export const steps = [
    "Details",
    "Assign Session",
    "Questions",
]

const editSteps = [
    "Details",
    "Questions",
]

function StepItem({
    index,
    title,
    selected,
    isLast,
}) {
    return (
        <div className="flex items-center gap-2">
            <div className={twMerge("w-6 h-6 flex items-center justify-center text-xs rounded-full text-white", selected ? "bg-PraxisTerracotta" : "bg-text-gray-500")}>{index + 1}</div>
            <div className={twMerge("whitespace-nowrap text-sm font-medium", selected ? "text-PraxisTerracotta" : "text-text-gray-500")}>{title}</div>
            {!isLast && <div className={twMerge("min-w-[87px] h-[2px] rounded-full", selected ? "bg-PraxisTerracotta" : "bg-gray-200")} />}
        </div>
    );
}
export function CertificationSteps({ currentStep, isEdit }: { currentStep: number, isEdit: boolean }) {
    const stepList = isEdit ? editSteps : steps;
    const { certificationAssets } = useApp();
    const labels = certificationAssets?.labels || {};
    const sessionLabel = getLabel("session.singular", labels);
    const questionLabel = getLabel("question.plural", labels);
    const stepTitles = {
        "Details": "Details",
        "Assign Session": `Assign ${sessionLabel}`,
        "Questions": questionLabel,
    }
    return (
        <div className="flex items-center gap-2 w-full">
            {stepList.map((step, index) => (
                <StepItem key={index} index={index} title={stepTitles[step]} selected={index <= (currentStep - 1)} isLast={index === stepList.length - 1} />
            ))}
        </div>
    );
}